import React, { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import ScrollToTop from '../../components/ScrollToTop'

const MainLayout = () => {

    const pathname = useLocation().pathname

    useEffect(() => {
        if (pathname === '/') document.title = 'Ticket'
    }, [pathname])

    return (
        <>
            <Header />
            <div className="container__outlet">
                <Outlet />
            </div>
            <Footer />
            <ScrollToTop />
        </>
    )
}

export default MainLayout